import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './EnterpriseSection.module.css';

const EnterpriseSection = () => {
  const navigate = useNavigate();

  const navigateToEnterprise = () => {
    navigate('/enterprise');
  };

  return (
    <div className={styles.enterpriseSection}>
      <div className={styles.enterpriseContent}>
        <h2>For Business</h2>
        <p className={styles.enterpriseHeadline}>Interested in offering our tools to your own community?</p>
        
        <div className={styles.enterpriseDetails}>
          <p className={styles.valueProp}>
            Enhance your community's experience with our Discord bots that drive engagement 
            by providing both time-saving automation and profit-maximizing tools.
          </p>
        </div>

        <div className={styles.testimonial}>
            <blockquote>
                Best service and really great at taking feedback, the whole team.
            </blockquote>
            <div className={styles.testimonialAuthor}>
                — Wealth Nexus
            </div>
        </div>

        <button 
          className={styles.enterpriseCta}
          onClick={navigateToEnterprise}
        >
          Learn More About Enterprise
          <span className={styles.arrow}>→</span>
        </button>
      </div>
    </div>
  );
};

export default EnterpriseSection;